export const KM_TO_MILES = 0.621371;
export const MILES_TO_KM = 1.60934;

export type BranchDistanceUnit = string | undefined | null;

export const isMileDistanceUnit = (unit?: BranchDistanceUnit) =>
  unit === "mile" || unit === "miles" || unit === "imperial";

export const getDistanceUnitLabel = (unit?: BranchDistanceUnit, short = true) => {
  if (isMileDistanceUnit(unit)) {
    return short ? "mi" : "miles";
  }
  return "km";
};

export const convertKmToBranchDistance = (value: number, unit?: BranchDistanceUnit) =>
  isMileDistanceUnit(unit) ? value * KM_TO_MILES : value;

export const convertMilesToBranchDistance = (value: number, unit?: BranchDistanceUnit) =>
  isMileDistanceUnit(unit) ? value : value * MILES_TO_KM;

export const convertSmartcarDistanceToBranch = (
  value: number,
  smartCarUnitSystem?: string,
  branchDistanceUnit?: BranchDistanceUnit
) => {
  const valueInKm = smartCarUnitSystem === "imperial" ? value * MILES_TO_KM : value;
  return convertKmToBranchDistance(valueInKm, branchDistanceUnit);
};

export const formatDistanceValue = (value: number, fractionDigits = 1) => {
  if (!Number.isFinite(value)) {
    return "0";
  }
  const rounded = Number(value.toFixed(fractionDigits));
  return rounded.toLocaleString(undefined, {
    maximumFractionDigits: fractionDigits
  });
};

// Speed tracks the same branch distance-unit setting: mph for mile branches, km/h otherwise.
export const getSpeedUnitLabel = (unit?: BranchDistanceUnit) =>
  isMileDistanceUnit(unit) ? "mph" : "km/h";

export const convertMphToBranchSpeed = (value: number, unit?: BranchDistanceUnit) =>
  isMileDistanceUnit(unit) ? value : value * MILES_TO_KM;
